import { render, staticRenderFns } from "./PdfPreviewDialog.vue?vue&type=template&id=60615933&scoped=true&"
import script from "./PdfPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./PdfPreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PdfPreviewDialog.vue?vue&type=style&index=0&id=60615933&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60615933",
  null
  
)

export default component.exports